<template>
  <div class="ontag">
    <div class="ontag--content">
      <a @click="$router.go(-1)">&laquo; {{ $t('back') }}</a>
      <h1>{{ $t('OnTag.orderDetails') }}</h1>
      <h2 style="margin-top: 0">
        beställnings id: {{ specificorder.orderId }}
      </h2>
      <div class="contact-information">
        Kontaktperson: <strong>{{ specificorder.contactPerson }}</strong>
        <br />
        Epost: <strong>{{ specificorder.email }}</strong>
        <br />
        Telefonnummer: <strong>{{ specificorder.phoneNumber }}</strong>
      </div>
      <br />
      <div class="input">
        <label
          for="order-company"
          class="input__label">
          {{ $t('clubName') }}
        </label>
        <input
          type="text"
          name="order-company"
          id="order-company"
          class="input__input"
          v-model="specificorder.clubName"
          disabled />
      </div>
      <div class="input">
        <label
          for="order-date"
          class="input__label">
          {{ $t('OnTag.ScorecardOrder.orderDate') }}
        </label>
        <input
          type="text"
          name="order-company"
          id="order-company"
          class="input__input"
          v-model="specificorder.orderDateText"
          disabled />
      </div>
      <div class="input">
        <label
          for="order-export-date"
          class="input__label">
          {{ $t('OnTag.ScorecardOrder.orderExportDate') }}
        </label>
        <input
          type="text"
          name="order-export-date"
          id="order-export-date"
          class="input__input"
          v-model="specificorder.exportDateText"
          disabled />
      </div>
      <div class="input">
        <label
          for="order-scorecardTypeText"
          class="input__label">
          {{ $t('OnTag.ScorecardOrder.scorecardTypeText') }}
        </label>
        <input
          type="text"
          name="order-scorecardTypeText"
          id="order-scorecardTypeText"
          class="input__input"
          v-model="specificorder.scorecardTypeText"
          disabled />
      </div>
      <div class="input">
        <label
          for="order-quantity"
          class="input__label">
          {{ $t('OnTag.ScorecardOrder.quantity') }}
        </label>
        <input
          type="text"
          name="order-quantity"
          id="order-quantity"
          class="input__input"
          v-model="quantity"
          :disabled="specificorder.status !== 1" />
      </div>

      <div v-if="!isPrintingHouse">
        <div class="input">
          <label
            for="order-customerShippingPrice"
            class="input__label">
            {{ $t('OnTag.ScorecardOrder.customerShippingPrice') }}
          </label>
          <input
            type="text"
            name="order-customerShippingPrice"
            id="order-customerShippingPrice"
            class="input__input"
            v-model="customerShippingPrice"
            :disabled="specificorder.status !== 1" />
        </div>
        <div class="input">
          <label
            for="order-shippingCost"
            class="input__label">
            Fraktkostnad
          </label>
          <input
            type="text"
            name="order-shippingCost"
            id="order-shippingCost"
            class="input__input"
            v-model="shippingCost"
            :disabled="specificorder.status !== 1" />
        </div>
        <div class="input">
          <label
            for="order-printingCost"
            class="input__label">
            Tryckkostnad
          </label>
          <input
            type="text"
            name="order-printingCost"
            id="order-printingCost"
            class="input__input"
            v-model="specificorder.printingCost"
            disabled />
        </div>
        <div class="input">
          <label
            for="order-statusText"
            class="input__label">
            {{ $t('OnTag.ScorecardOrder.statusText') }}
          </label>
          <input
            type="text"
            name="order-statusText"
            id="order-statusText"
            class="input__input"
            v-model="specificorder.statusText"
            disabled />
        </div>
        <div class="input">
          <label
            for="order-unitprice"
            class="input__label">
            {{ $t('OnTag.ScorecardOrder.unitPrice') }}
          </label>
          <input
            type="number"
            name="order-unitprice"
            id="order-unitprice"
            class="input__input"
            v-model="unitPrice"
            :disabled="specificorder.status !== 1" />
        </div>
        <div class="input">
          <label
            for="order-unitprice"
            class="input__label">
            {{ $t('OnTag.ScorecardOrder.unitCostPrice') }}
          </label>
          <input
            type="number"
            name="order-unitcostprice"
            id="order-unitcostprice"
            class="input__input"
            v-model="unitCostPrice"
            :disabled="specificorder.status !== 1" />
        </div>
      </div>
      <div
        class="input"
        v-on:click="toggleForm">
        <label
          for="order-deliveryAddress"
          class="input__label clickable">
          {{ $t('OnTag.ScorecardOrder.deliveryAddress') }}
          <span
            class="arrow"
            v-if="showForm">
            ▼
          </span>
          <span
            class="arrow"
            v-else>
            ▲
          </span>
        </label>
        <input
          type="text"
          name="order-deliveryAddress"
          id="order-deliveryAddress"
          class="input__input"
          v-model="deliveryAddress"
          disabled />
      </div>
      <div
        class="delivery-form"
        v-if="showForm">
        <div class="input">
          <label for="companyName">Företagsnamn: </label>
          <input
            type="text"
            class="input__input"
            id="companyname"
            v-model="tempDeliveryAddress.companyName"
            :disabled="specificorder.status !== 1" />
        </div>
        <div class="input">
          <label for="postalAddress">Gatuaddress:</label>
          <input
            type="text"
            class="input__input"
            id="postalAddress"
            v-model="tempDeliveryAddress.postalAddress"
            :disabled="specificorder.status !== 1" />
        </div>
        <div class="input">
          <label for="postalCode">Postkod</label>
          <input
            type="text"
            class="input__input"
            id="postalCode"
            v-model="tempDeliveryAddress.postalCode"
            :disabled="specificorder.status !== 1" />
        </div>
        <div class="input">
          <label for="city">Stad:</label>
          <input
            type="text"
            class="input__input"
            id="city"
            v-model="tempDeliveryAddress.city"
            :disabled="specificorder.status !== 1" />
        </div>
      </div>
      <div
        v-if="specificorder.isClubSpecific"
        class="input">
        <label
          for="order-deliveryWeek"
          class="input__label">
          {{ $t('deliveryWeek') }}
        </label>
        <select
          class="input__select"
          v-model="selectedWeekClub"
          :disabled="specificorder.status !== 1">
          <option
            v-for="week in deliveryweeks.filter(
              w =>
                w.year === new Date().getFullYear() ||
                w.year === new Date().getFullYear() + 1
            )"
            :key="week.id"
            :value="week">
            v. {{ week.week }}, {{ week.year }} - Deadline:
            {{ new Date(week.deadline).toLocaleDateString('sv-SE') }} - Deadline
            for Change:
            {{ new Date(week.deadlineForChange).toLocaleDateString('sv-SE') }}
          </option>
        </select>
      </div>
      <div
        v-else-if="!specificorder.isClubSpecific"
        class="input">
        <label
          for="order-deliveryWeek"
          class="input__label">
          {{ $t('deliveryWeek') }}
        </label>
        <input
          type="number"
          name="order-deliveryWeek"
          id="order-deliveryWeek"
          class="input__input"
          v-model="deliveryWeek"
          :disabled="specificorder.status !== 1" />
      </div>
      <div v-if="!isPrintingHouse">
        <div class="input">
          <label
            for="order-invoiceAddress"
            class="input__label">
            {{ $t('OnTag.ScorecardOrder.orgNumber') }}
          </label>
          <input
            type="text"
            name="order-invoiceAddress"
            id="order-invoiceAddress"
            class="input__input"
            v-model="specificorder.invoiceAddress.orgNumber"
            disabled />
        </div>
        <div class="input">
          <label
            for="order-invoiceAddress"
            class="input__label">
            {{ $t('emailInvoice') }}
          </label>
          <input
            type="text"
            name="order-invoiceAddress"
            id="order-invoiceAddress"
            class="input__input"
            v-model="specificorder.invoiceAddress.email"
            disabled />
        </div>
        <div class="input">
          <label
            for="order-customerComment"
            class="input__label">
            {{ $t('OnTag.ScorecardOrder.customerComment') }}
          </label>
          <input
            type="text"
            name="order-customerComment"
            id="order-customerComment"
            class="input__input"
            v-model="specificorder.comment"
            disabled />
        </div>
        <div class="input">
          <label
            for="order-terpID"
            class="input__label">
            Terp ID
          </label>
          <input
            type="text"
            name="order-terpID"
            id="order-terpID"
            class="input__input"
            v-model="specificorder.invoiceAddress.terpId"
            disabled />
        </div>
      </div>

      <div
        v-if="specificorder.isClubSpecific"
        class="input">
        <label
          for="order-hasChanges"
          class="input__label">
          Lack
        </label>
        <select
          :disabled="specificorder.status !== 1"
          name="order-hasChanges"
          id="order-hasChanges"
          class="input__select"
          v-model="surface">
          <option value="2">{{ $t('glossy') }}</option>
          <option value="1">{{ $t('mat') }}</option>
        </select>
      </div>
      <div
        v-if="specificorder.isClubSpecific"
        class="input">
        <label
          for="order-hasChanges"
          class="input__label">
          Ändring av lack
        </label>
        <select
          :disabled="specificorder.status !== 1"
          name="order-hasSurfaceChanges"
          id="order-hasSurfaceChanges"
          class="input__select"
          v-model="surfaceChange">
          <option value="true">{{ $t('yes') }}</option>
          <option value="false">{{ $t('no') }}</option>
        </select>
      </div>
      <div
        v-if="specificorder.isClubSpecific"
        class="input">
        <label
          for="order-hasChanges"
          class="input__label">
          Ändring av layout
        </label>
        <input
          type="text"
          name="order-hasChanges"
          id="order-hasChanges"
          class="input__input"
          :value="specificorder.hasChanges ? 'Ja' : 'Nej'"
          disabled />
      </div>

      <div v-if="!isPrintingHouse">
        <div
          v-if="specificorder.isClubSpecific"
          class="input">
          <label
            for="order-changeCost"
            class="input__label">
            Kostnad för ändring (kr/exkl. moms)
          </label>
          <input
            v-model="changeCost"
            type="number"
            name="order-changeCost"
            id="order-changeCost"
            class="input__input"
            :disabled="specificorder.status !== 1" />
        </div>
        <div
          v-if="specificorder.isClubSpecific"
          class="input">
          <label
            for="order-changePrice"
            class="input__label">
            Pris för ändring (kr/exkl. moms)
          </label>
          <input
            v-model="changePrice"
            type="number"
            name="order-changePrice"
            id="order-changePrice"
            class="input__input"
            :disabled="specificorder.status !== 1" />
        </div>
      </div>
      <div class="input">
        <label
          for="order-adminComment"
          class="input__label">
          Kommentar från OnTag AB
        </label>
        <input
          maxlength="200"
          type="text"
          name="order-adminComment"
          id="order-adminComment"
          class="input__input"
          v-model="adminComment"
          :disabled="isPrintingHouse" />
      </div>

      <div v-if="!isPrintingHouse">
        <div
          class="input"
          v-if="specificorder.combinedTodoStatus != ''">
          <label
            for="order-combinedTodoStatus"
            class="input__label">
            Status på CombinedTodo
          </label>
          <input
            type="text"
            name="order-combinedTodoStatus"
            id="order-combinedTodoStatus"
            class="input__input"
            v-model="specificorder.combinedTodoStatus"
            disabled />
        </div>
        <div
          class="input"
          v-if="specificorder.costTodoStatus != ''">
          <label
            for="order-costTodoStatus"
            class="input__label">
            Status på EventTodo
          </label>
          <input
            type="text"
            name="order-costTodoStatus"
            id="order-costTodoStatus"
            class="input__input"
            v-model="specificorder.costTodoStatus"
            disabled />
        </div>
        <div
          class="input"
          v-if="specificorder.fundingTodoStatus != ''">
          <label
            for="order-fundingTodoStatus"
            class="input__label">
            Status på Revenue/Cost
          </label>
          <input
            type="text"
            name="order-fundingTodoStatus"
            id="order-fundingTodoStatus"
            class="input__input"
            v-model="specificorder.fundingTodoStatus"
            disabled />
        </div>
      </div>
      <div class="input">
        <div class="">
          <label
            for="order-trackingNumber"
            class="input__label label__inline">
            Spårningsnummer
          </label>
          <span class="input__label--tracking-link">
            <a
              target="_blank"
              :href="
                'https://www.dhl.com/se-en/home/tracking.html?tracking-id=' +
                trackingNumber
              ">
              https://www.dhl.com/se-en/home/tracking.html?tracking-id={{
                trackingNumber
              }}
            </a>
          </span>
        </div>
        <div>
          <input
            type="text"
            maxlength="200"
            name="order-trackingNumber"
            id="order-trackingNumber"
            class="input__input"
            :disabled="specificorder.status != 4 && !isPrintingHouse"
            v-model="trackingNumber" />
          <br />
          <div class="input-group--inline">
            <base-button
              :text="$t('markAsShipped')"
              type="submit"
              :disabled="
                specificorder.status != 4 ||
                this.trackingNumber === '' ||
                this.trackingNumber === 0 ||
                this.trackingNumber === undefined
              "
              @click="shipOrder"
              v-element-loader="{ loaderKey: 'edit-order' }" />
            <base-button
              v-if="specificorder.status == 7"
              :text="$t('markAsNotShipped')"
              type="submit"
              :disabled="specificorder.status != 7"
              @click="unshipOrder"
              v-element-loader="{ loaderKey: 'edit-order' }" />
          </div>
        </div>
      </div>
      <div
        v-if="
          specificorder.shippedBy != undefined && specificorder.shippedBy != ''
        ">
        <p>
          Markerad som skickad:
          {{ specificorder.shippedDateText + ' av ' + specificorder.shippedBy }}
        </p>
      </div>
      <div
        v-if="
          specificorder.exportedBy != undefined &&
          specificorder.exportedBy != ''
        ">
        <p>
          Manuell export:
          {{ specificorder.exportDateText + ' av ' + specificorder.exportedBy }}
        </p>
      </div>
      <div
        v-if="
          specificorder.confirmedBy != undefined &&
          specificorder.confirmedBy != ''
        ">
        <p>
          Bekräftad:
          {{ specificorder.confirmedDate + ' av ' + specificorder.confirmedBy }}
        </p>
      </div>
      <div
        v-if="
          specificorder.canceledBy != undefined &&
          specificorder.canceledBy != ''
        ">
        <p>
          Annullerad:
          {{ specificorder.canceledDate + ' av ' + specificorder.canceledBy }}
        </p>
      </div>
      <div
        v-if="!isPrintingHouse"
        class="ontag--utilitites input-group--inline">
        <base-button
          :text="'Spärra'"
          type="submit"
          @click="showLockOrderModal = true"
          class="button--background-red"
          :disabled="[1, 4, 5].includes(specificorder.status)" />
        <modal-window :show="showLockOrderModal">
          <div class="modal__header">Spärra order</div>
          <div class="modal__content">
            <div>
              <h2>Är du säker på att du vill spärra beställningen?</h2>
            </div>
          </div>
          <div class="modal__content--actions">
            <base-button
              class="button--background-gray-dark"
              :text="$t('cancel')"
              @click="showLockOrderModal = false">
            </base-button>
            <base-button
              :text="'Bekräfta'"
              @click="lockOrder"
              class="button--background-red"
              v-element-loader="{ loaderKey: 'status-order' }" />
          </div>
        </modal-window>

        <base-button
          :text="'Frisläpp'"
          type="submit"
          @click="showReleaseOrderModal = true"
          :disabled="specificorder.status != 1" />
        <modal-window :show="showReleaseOrderModal">
          <div class="modal__header">Frisläpp order</div>
          <div class="modal__content">
            <div>
              <h2>Är du säker på att du vill frisläppa beställningen?</h2>
            </div>
          </div>
          <div class="modal__content--actions">
            <base-button
              class="button--background-gray-dark"
              :text="$t('cancel')"
              @click="showReleaseOrderModal = false">
            </base-button>
            <base-button
              :text="'Bekräfta'"
              @click="releaseOrder"
              class="button--background-red"
              v-element-loader="{ loaderKey: 'status-order' }" />
          </div>
        </modal-window>

        <base-button
          :text="$t('save')"
          type="submit"
          @click="saveOrder"
          v-element-loader="{ loaderKey: 'edit-order' }" />
        <base-button
          :text="'Exportera'"
          type="submit"
          @click="toggleExportModal"
          :disabled="specificorder.status !== 3" />
        <modal-window :show="showExportModal">
          <div class="modal__header">Markera som exporterad</div>
          <div class="modal__content">
            <div>
              <h2>Är du säker på att du vill markera ordern som exporterad?</h2>
            </div>
          </div>
          <div class="modal__content--actions">
            <base-button
              class="button--background-gray-dark"
              :text="$t('cancel')"
              @click="toggleExportModal">
            </base-button>
            <base-button
              :text="'Bekräfta'"
              @click="exportOrder"
              v-element-loader="{ loaderKey: 'export-orders' }" />
          </div>
        </modal-window>
        <base-button
          :text="'Annullera'"
          type="submit"
          @click="toggleCancelOrderModal"
          class="button--background-red"
          :disabled="specificorder.status == 5" />
        <modal-window :show="showCancelOrderModal">
          <div class="modal__header">Annullera order</div>
          <div class="modal__content">
            <div>
              <h2
                v-if="specificorder.status === 1 || specificorder.status === 2">
                Är du säker på att du vill annullera beställningen? Leverantören
                aviseras inte av systemet och du måste kontakta denna och
                meddela att beställningen skall annulleras
              </h2>
              <h2 v-else>
                Är du säker på att du vill annullera beställningen?
              </h2>
            </div>
          </div>
          <div class="modal__content--actions">
            <base-button
              class="button--background-gray-dark"
              :text="$t('cancel')"
              @click="toggleCancelOrderModal">
            </base-button>
            <base-button
              :text="'Bekräfta'"
              @click="cancelOrder"
              class="button--background-red"
              v-element-loader="{ loaderKey: 'cancel-order' }" />
          </div>
        </modal-window>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/form-elements/base-button';
import ModalWindow from '@/components/modal/modal';
import elementLoader from '@/directives/element-loader';

export default {
  name: 'EditOrder',

  components: {
    BaseButton,
    ModalWindow,
  },
  directives: {
    elementLoader,
  },

  props: {
    id: {
      type: String,
      default: '0',
    },
  },

  data() {
    return {
      deliveryAddress: '',
      deliveryWeek: 0,
      showForm: '',
      invoiceAddress: '',
      adminComment: '',
      changePrice: '',
      customerShippingPrice: 0,
      quantity: 0,
      shippingCost: 0,
      changeCost: '',
      trackingNumber: '',
      unitPrice: 0,
      unitCostPrice: 0,
      surface: '',

      surfaceChange: false,
      showCancelOrderModal: false,
      showConfirmOrderModal: false,
      showInvoicedModal: false,
      showExportModal: false,
      showLockOrderModal: false,
      showReleaseOrderModal: false,
      selectedWeekClub: null,
      tempDeliveryAddress: {
        postalCode: '',
        postalAddress: '',
        city: '',
        companyName: '',
      },
    };
  },

  watch: {
    'specificorder.adminComment': function (newVal) {
      this.adminComment = newVal;
    },
    tempDeliveryAddress: {
      handler() {
        const { companyName, postalAddress, postalCode, city } =
          this.tempDeliveryAddress;
        this.deliveryAddress = `${companyName}, ${postalAddress}, ${postalCode}, ${city}`;
      },
      deep: true,
    },
  },

  methods: {
    saveOrder() {
      let orderData = {
        id: this.specificorder.id,
      };

      if (this.adminComment) orderData.adminComment = this.adminComment;
      if (this.changePrice) orderData.changePrice = this.changePrice;
      if (this.changeCost) orderData.changeCost = this.changeCost;
      if (this.surface) orderData.surface = this.surface;
      if (this.customerShippingPrice)
        orderData.customerShippingPrice = this.customerShippingPrice;
      if (this.shippingCost) orderData.shippingCost = this.shippingCost;
      if (this.quantity) orderData.quantity = this.quantity;
      if (this.surfaceChange) orderData.surfaceChange = this.surfaceChange;
      if (this.unitPrice) orderData.unitPrice = this.unitPrice;
      if (this.unitCostPrice) orderData.unitCostPrice = this.unitCostPrice;
      if (this.tempDeliveryAddress)
        orderData.deliveryAddress = this.tempDeliveryAddress;
      if (!this.specificorder.isClubSpecific) {
        orderData.deliveryWeek = this.deliveryWeek;
      }
      if (this.selectedWeekClub)
        orderData.scorecardDeliveryWeekExternalId = this.selectedWeekClub.id;

      this.$store
        .dispatch('scorecardOrder/patchScorecardSpecificOrder', orderData)
        .then(() => {
          this.$router.go(-1);
        });
    },
    shipOrder() {
      this.$store
        .dispatch('scorecardOrder/patchScorecardShipOrder', {
          id: this.specificorder.id,
          trackingNumber: this.trackingNumber,
          status: 7,
        })
        .then(() => {
          this.$router.go(-1);
        });
    },
    toggleForm() {
      this.showForm = !this.showForm;
    },
    unshipOrder() {
      this.$store
        .dispatch('scorecardOrder/patchScorecardShipOrder', {
          id: this.specificorder.id,
          trackingNumber: null,
          status: 4,
        })
        .then(() => {
          this.$router.go(-1);
        });
    },
    toggleConfirmModal() {
      this.showConfirmOrderModal = !this.showConfirmOrderModal;
    },
    exportOrder() {
      if (
        this.specificorder.scorecardType === 1 ||
        this.specificorder.scorecardType === 2 ||
        this.specificorder.scorecardType === 6
      ) {
        this.$store
          .dispatch('scorecardOrder/postScorecardOrderExportStandard', {
            ids: [this.specificorder.id],
            scorecardType: 'standard',
            value: true,
          })
          .then(() => {
            this.$router.go(-1);
          });
      } else {
        this.$store
          .dispatch('scorecardOrder/postScorecardOrderExportCustomer', {
            ids: [this.specificorder.id],
            scorecardType: 'customer',
            value: true,
          })
          .then(() => {
            this.$router.go(-1);
          });
      }
    },
    confirmOrder() {
      if (this.specificorder.status === 2) {
        this.$store
          .dispatch('scorecardOrder/patchScorecardOrderConfirm', {
            ids: [this.specificorder.id],
            scorecardType: '273x110',
            value: false,
          })
          .then(() => {
            this.$router.go(-1);
          });
      } else {
        this.$store
          .dispatch('scorecardOrder/patchScorecardOrderConfirm', {
            ids: [this.specificorder.id],
            scorecardType: '273x110',
            value: true,
          })
          .then(() => {
            this.$router.go(-1);
          });
      }
    },
    toggleExportModal() {
      this.showExportModal = !this.showExportModal;
    },
    toggleInvoicedModal() {
      this.showInvoicedModal = !this.showInvoicedModal;
    },
    invoiceOrder() {
      if (this.specificorder.invoiced === true) {
        this.$store
          .dispatch('scorecardOrder/patchScorecardOrderInvoiced', {
            ids: [this.specificorder.id],
            scorecardType: '273x110',
            value: false,
          })
          .then(() => {
            this.$router.go(-1);
          });
      } else {
        this.$store
          .dispatch('scorecardOrder/patchScorecardOrderInvoiced', {
            ids: [this.specificorder.id],
            scorecardType: '273x110',
            value: true,
          })
          .then(() => {
            this.$router.go(-1);
          });
      }
    },
    toggleCancelOrderModal() {
      this.showCancelOrderModal = !this.showCancelOrderModal;
    },
    cancelOrder() {
      this.$store
        .dispatch('scorecardOrder/patchScorecardOrderStatus', {
          id: this.specificorder.id,
          ScorecardStatus: 5,
        })
        .then(() => {
          this.$router.go(-1);
        });
    },
    lockOrder() {
      this.$store
        .dispatch('scorecardOrder/patchScorecardOrderStatus', {
          id: this.specificorder.id,
          ScorecardStatus: 1,
        })
        .then(() => {
          this.$router.go(-1);
        });
    },
    releaseOrder() {
      this.$store
        .dispatch('scorecardOrder/patchScorecardOrderStatus', {
          id: this.specificorder.id,
          ScorecardStatus: 3,
        })
        .then(() => {
          this.$router.go(-1);
        });
    },
  },

  computed: {
    specificorder() {
      return this.$store.getters['scorecardOrder/scorecardspecificorder'];
    },
    user() {
      return this.$store.getters['user/user'];
    },
    isPrintingHouse() {
      return (
        this.user.roles.OnTag &&
        this.user.roles.OnTag.some(e => e.value === 'PrintingHouse')
      );
    },
    deliveryweeks() {
      return this.$store.getters['scorecardOrder/deliveryweeks'];
    },
  },
  async mounted() {
    await this.$store
      .dispatch('scorecardOrder/fetchDeliveryWeeks')
      .then(async () => {
        await this.$store
          .dispatch('scorecardOrder/fetchScorecardSpecificOrder', {
            id: this.id,
          })
          .then(() => {
            const {
              trackingNumber,
              adminComment,
              changeCost,
              surfaceChange,
              surface,
              changePrice,
              unitPrice,
              deliveryCompanyName,
              deliveryPostalAddress,
              deliveryPostalCode,
              deliveryCity,
              invoiceAddress,
              deliveryWeekText,
              customerShippingPrice,
              quantity,
              shippingCost,
              unitCostPrice,
            } = this.specificorder;

            this.trackingNumber = trackingNumber;
            this.adminComment = adminComment;
            this.changeCost = changeCost;
            this.surfaceChange = surfaceChange;
            this.surface = surface;
            this.changePrice = changePrice;
            this.unitPrice = unitPrice;
            this.deliveryAddress = `${deliveryCompanyName}, ${deliveryPostalAddress}, ${deliveryPostalCode}, ${deliveryCity}`;
            this.tempDeliveryAddress = {
              companyName: deliveryCompanyName,
              postalAddress: deliveryPostalAddress,
              postalCode: deliveryPostalCode,
              city: deliveryCity,
            };

            this.customerShippingPrice = customerShippingPrice;
            this.quantity = quantity;
            this.shippingCost = shippingCost;
            this.unitCostPrice = unitCostPrice;

            this.selectedWeekClub = this.deliveryweeks.find(
              week => week.id === deliveryWeekText
            );
            this.deliveryWeek = this.specificorder.deliveryWeek;

            if (!this.isPrintingHouse && invoiceAddress) {
              const { postalAddress, postalCode, city } = invoiceAddress;
              this.invoiceAddress = `${deliveryCompanyName}, ${postalAddress}, ${postalCode}, ${city}`;
            }
          })
          .catch(error => {
            console.error('Failed to fetch scorecard specific order:', error);
          });
      });
  },
};
</script>

<style lang="scss" scoped>
.contact-information {
  h3 {
    display: inline;
  }
}
.input__label--tracking-link {
  margin-left: 24px;
  font-size: 14px;
  font-style: italic;
  a {
    color: color(ontag-blue);
  }
}

.input__select {
  display: flex;
  padding: 0.5rem;
  width: 100%;
  background-color: color(gray-lighter);
  border-radius: 2px;
  border: solid 1px color(gray);
  color: color(text-color);
}

.transparent-button {
  width: 33px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.delivery-form {
  border: 3px solid color(gray);
  background-color: color(gray-light);
  padding: 8px;
}

.arrow {
  color: color(gray-darker);
}

.clickable {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>
